module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The 1842 Royal Commission Report")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This referred to the following collieries in Barnsley:")]), _vm._v(" "), _c('div', {
    staticClass: "quote1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Messrs Day and Twibell’s at Mount Osbourne")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Messrs Hopwood and Jackson’s Barnsley New Colliery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Messrs Traviss and Horsfall’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Executives of Mr Samuel Thorpe’s Gawber Colliery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Messrs Micklethwaite and Co’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Messrs Charlesworth’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mr Clarke’s two in Silkstone")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Messrs Field, Cooper and Co’s two in Stainborough")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mr Thomas Wilson’s Kexborough Colliery at Darton")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Gin Pit at Mapplewell.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Drawing of a typical colliery in the 1842 Royal Commission Report. (© National Coalmining Museum)")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Testimony from Interviews c.1840")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Interviews with owners, managers and workers shared some fascinating details about working conditions, although they were not always truthful.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("William Hopwood")]), _vm._v(" (No. 80) explained that children usually began work in the mine aged 8 years as Trappers, starting work between 6 and 7am and finishing between 3 and 5pm; they were Hurriers at 10 years then "), _c('span', {
    attrs: {
      "href": "#/xhtml/72_Glossary#glo6",
      "id": "sglo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getters")]), _vm._v(" at 16.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In most of the pits round Barnsley, girls are employed in trapping and hurrying; they do the same work as the boys; and leave the pits at 16 or 17 years old, they are generally employed by their own parents and under their own control. I think no bad result ensues to their morals or their health. They generally work in boys’ clothes, but not always.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("(Trappers were paid 3 shillings a week, Hurriers 10/- while Colliers could earn 3/9 per day after paying Hurriers).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Sarah Gooder")]), _vm._v(" (No. 116) aged 8, admitted to being scared while having to work as a "), _c('span', {
    attrs: {
      "href": "#/xhtml/72_Glossary#glo15",
      "id": "sglo15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trapper")]), _vm._v(" in the dark; she would sing to herself on occasions when she had a light but was too afraid without.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Mr George Traviss")]), _vm._v(" (No. 84) stated that,")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("hurrying is tolerably hard work... Our present corves are six and a half cwt when full, but we are going to make them larger, when they will weigh nine cwt. [One hundredweight was probably double the weight of a 10-year-old child, who might have to push twenty corves a day over a considerable distance; the corves at Gawber Colliery weighed 12.5 cwt]. I do not think the children are over-worked so as to hurt them. They always appear to me to be very cheerful and run and play about when they come out of the pit in the evening…. Colliers’ children are generally well fed … they take their dinner with them, they bring out great pieces of bread in their hands and meat or cheese.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("However, "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("Maria Gooder")]), _vm._v(" (No. 112) aged 12, disagreed:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is hard work and tires me a good deal in my back mostly…. It is very cold often…. We have dry bread for dinner and nothing else. We don’t have cheese or butter nor meat. There is water in the pit but we don’t sup it. Sometimes the men let us have a little beer, but not always…. When we come up we go and have our dinner, sometimes it’s meat and potatoes, and sometimes pudding… I don’t like being in the pit. I am tired and afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("A collier")]), _vm._v(" (No. 94) confirmed that workers got an hour for their lunch (unpaid) during their twelve-hour shift as the "), _c('span', {
    attrs: {
      "href": "#/xhtml/72_Glossary#glo5",
      "id": "sglo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("engine")]), _vm._v(" stopped.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("It would be very awkward for children to come out before the men. It would be too much trouble to draw them up and down twice as often, and there would be more chance of accidents…. Sometimes the pits work at night but not generally. The children get but little schooling.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Eliza Coats")]), _vm._v(" (No. 115) aged 11, said that she had never been to school because she had no shoes and, like many of the children tested, had little understanding of religion: ‘I think God made the world, but I don’t know where God is. I never heard of Jesus Christ.’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Mrs Fern")]), _vm._v(" (No. 144) a collier’s wife who had herself worked in a pit for eleven years, explained that her stepdaughter Ann worked in a colliery because she had been unable to get her into service. Ann had not attended Sunday School that winter because, ‘I wanted her to stay at home and learn some jobs at house … she can read pretty well at Testament … Ann can knit very well and sew middling.’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("The agent for Gawber Colliery")]), _vm._v(" (No. 118) reckoned that only three of his men out of fifty could sign his own name.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("There were mixed opinions about whether girls should be allowed to work in pits but some men felt very strongly that it was wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('span', {
    staticClass: "underline"
  }, [_vm._v("John Thorneley")]), _vm._v(" (No. 96) JP with forty years’ experience in the management of collieries, condemned it as ‘a most awfully demoralising practice. The youths of both sexes work often in a half-naked state and the passions are excited before they arrive at puberty. Sexual intercourse decidedly frequently occurs in consequence. Cases of bastardy also frequently occur.’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Dr Michael Thomas Sadler")]), _vm._v(" (No. 139) surgeon with eighteen years’ experience in Barnsley, had come across diseases of the heart associated with the ‘violent exertions’ of miners, who looked pale through absence of natural light and did not have long lives, although they generally lived well. Their children looked strong but he felt light was ‘essential to perfect health’, and ‘ventilation of pits of the greatest importance to health’. Dr Sadler stated: ‘It is a brutalising practice for women to be in collieries, the effect on their morals is very bad…. It is impossible to prevent accidents altogether, but they might be much diminished with more care and prudence.’ Dr Sadler subsequently became the Medical Officer of Health for Barnsley and, in his report in 1866, he highlighted ‘the deplorable standards of housing and of sanitation in large areas of the south and south western parts of the town’, with ‘the relatively high death rate among tenants of the crowded courts’ and ‘the highly objectionable back to back houses’; he advocated the building of public baths.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Another Surgeon")]), _vm._v(" (No. 99) with twenty-four years’ experience was aware of a number of women who continued to work in pits after getting married and even when pregnant, close to confinement.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Illustration of female colliers in the 1842 Royal Commission Report. (Courtesy of the National Coalmining Museum)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("A meeting of Yorkshire Coal Owners was held in May 1841 to discuss the recommendations of the Royal Commission. They protested that any legislation and the appointment of an Inspector were a ‘violation of every maxim of civil and commercial freedom’. They believed that keeping a register of children with medical and educational entries would cost them time and money, they objected to keeping records that could incriminate them and the ‘vexatious system of espionage which is fundamentally interwoven with any provision of the Act’. They ‘deny that there is anything in the nature of the employment in coal or iron mines that affects the health, since in this respect miners may be favourably contrasted with the general population’, but they conceded to the exclusion of females and boys under 8 from working underground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1842 Report also provided details of pay rates in Yorkshire: (1 shilling is worth £40 today) Trappers received 6d a day; Hurriers aged 11 years old earned 5 shillings a week, aged 14+ 8 shillings, and aged 17+ 12 shillings; men’s wages varied according to ‘their industry and strength’, but a young able-bodied man earned between 20 to 25 shillings a week. Colliery owners and managers took advantage of their employees by operating a ‘truck system’ whereby workers received at least some of their pay in tokens or vouchers that had to be spent in their ‘tommy shop’, restricting choice and competition.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The White Bear Inn at Hoyle Mill, where inquests were held. (Courtesy of the Tasker Trust)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82bb28d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter05.vue
// module id = 90
// module chunks = 0